<script setup>
const props = defineProps({
  modelValue: Boolean,
  title: String,
  text: String,
  confirmText: { type: String, default: 'OK' },
  cancelText: { type: String, default: 'Cancel' },
  confirmColor: { type: String, default: 'primary' },
  cancelColor: { type: String, default: 'grey' }
})
const emit = defineEmits(['update:modelValue', 'confirm'])

const close = () => emit('update:modelValue', false)
const confirm = () => {
  emit('confirm')
  close()
}
</script>

<template>
  <v-dialog :model-value="modelValue" @update:model-value="close" max-width="400" @keyup.enter="confirm" tabindex="0">
    <v-card>
      <v-card-title class="text-h6">
        {{ title }}
      </v-card-title>
      <v-card-text v-if="text">
        {{ text }}
      </v-card-text>
      <v-card-actions>
        <v-spacer />
        <v-btn :color="cancelColor" variant="text" @click="close">
          {{ cancelText }}
        </v-btn>
        <v-btn :color="confirmColor" variant="elevated" @click="confirm">
          {{ confirmText }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>
